import axios from "axios";
/**
 * Webinar詳細の初期化
 */
export function initWebinarDetail() {
    const app = document.getElementById("user-webinar-detail-app");
    if (app === null) {
        return;
    }
    initWebinarVideoPlay();
    initWebinarVisit();
    initWebinarFavoriteButton();
    initWebinarQuestionnaireButton();
    initWebinarQuestionnaireModal();
    initWebinarQuestionnaireInput();
    initRelatedWebinarShowMoreButton();
}
/**
 * 関連ウェビナーもっと見るボタンのイベント処理
 */
function initRelatedWebinarShowMoreButton() {
    const btn = document.getElementById("related-webinar-show-more-btn");
    if (btn === null) {
        return;
    }
    btn.addEventListener("click", function () {
        const items = document.getElementsByClassName("related-webinar-item");
        for (let i = 0; i < items.length; i++) {
            items[i].style.display = "flex";
        }
        btn.style.display = "none";
    }, false);
}
/**
 * アンケート確認/完了モーダルの初期化
 */
function initWebinarQuestionnaireModal() {
    const form = document.getElementById("webinar-questionarrie-form");
    const items = new Array("q1", "q2", "q3");
    for (let i = 0; i < items.length; i++) {
        let item = items[i];
        let elements = document.getElementsByName(item + "_confirm");
        for (let j = 0; j < elements.length; j++) {
            elements[j].innerHTML = form.elements[item].value;
        }
    }
}
/**
 * アンケートフォームの入力イベント処理
 */
function initWebinarQuestionnaireInput() {
    let modalAreaElements = document.getElementsByClassName("modal-area");
    if (modalAreaElements.length > 0) {
        let inputElements = modalAreaElements[0].getElementsByTagName("input");
        for (let i = 0; i < inputElements.length; i++) {
            try {
                inputElements[i].addEventListener("change", () => {
                    let name = inputElements[i].getAttribute("name");
                    let value = inputElements[i].value;
                    let confirmElement = document.getElementsByName(name + "_confirm");
                    for (let j = 0; j < confirmElement.length; j++) {
                        confirmElement[j].innerHTML = value;
                    }
                });
            }
            catch (e) { }
        }
        let textAreaElements = modalAreaElements[0].getElementsByTagName("textarea");
        for (let i = 0; i < textAreaElements.length; i++) {
            try {
                textAreaElements[i].addEventListener("change", () => {
                    let name = textAreaElements[i].getAttribute("name");
                    let value = textAreaElements[i].value;
                    let confirmElement = document.getElementsByName(name + "_confirm");
                    for (let j = 0; j < confirmElement.length; j++) {
                        confirmElement[j].innerHTML = value;
                    }
                });
            }
            catch (e) { }
        }
    }
}
/**
 * アンケートフォームのボタンイベント処理
 */
function initWebinarQuestionnaireButton() {
    let modalWrapperElements = document.getElementsByClassName("modal-content");
    if (modalWrapperElements.length > 0) {
        let buttonElements = document.getElementsByClassName("modal-button");
        for (let i = 0; i < buttonElements.length; i++) {
            buttonElements[i].addEventListener("click", function (event) {
                let next = parseInt(buttonElements[i].dataset.next);
                changeScene(next, false);
            }, false);
        }
        /**
         * モーダル処理
         */
        function changeScene(nextScene, afterPost) {
            if (afterPost == false) {
                // 確認ボタン
                if (nextScene == 2) {
                    if (invalid()) {
                        return;
                    }
                }
                // 送信ボタン
                else if (nextScene == 3) {
                    postAnswer();
                    return;
                }
            }
            // 送信用の axios もしくは ajax の処理はここで記述し、完了後に is-show class の削除と changeScene の実行により初期状態に戻すこと。
            if (nextScene == modalWrapperElements.length + 1) {
                let modalAreaElements = document.getElementsByClassName("modal-area");
                if (modalAreaElements.length > 0) {
                    modalAreaElements[0].classList.remove("is-show");
                    setTimeout(() => {
                        changeScene(1, false);
                    }, 1000);
                    return;
                }
            }
            for (let i = 0; i < modalWrapperElements.length; i++) {
                let index = parseInt(modalWrapperElements[i].dataset.index);
                if (nextScene == index) {
                    setTimeout(() => {
                        modalWrapperElements[i].classList.add("show");
                    }, 500);
                }
                else {
                    modalWrapperElements[i].classList.remove("show");
                }
            }
        }
        /**
         * validation
         */
        function invalid() {
            const form = document.getElementById("webinar-questionarrie-form");
            // 入力チェック
            let isError = false;
            const items = new Array("q1", "q2");
            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                if (form.elements[item].value.length == 0) {
                    document.getElementById(item + "_error").style.display = "block";
                    isError = true;
                }
                else {
                    document.getElementById(item + "_error").style.display = "none";
                }
            }
            if (form.elements["q3"].value.length > 200) {
                document.getElementById("q3_error").style.display = "block";
                isError = true;
            }
            else {
                document.getElementById("q3_error").style.display = "none";
            }
            return isError;
        }
        /**
         * アンケート回答登録
         */
        function postAnswer() {
            const form = document.getElementById("webinar-questionarrie-form");
            const formData = {
                webinar_questionnaire_id: form.elements["webinar_questionnaire_id"].value,
                answers: {
                    answer_1: form.elements["q1"].value,
                    answer_2: form.elements["q2"].value,
                    answer_3: form.elements["q3"].value,
                },
            };
            axios
                .post(`/api/webinar-questionnaire-answers`, formData, { withCredentials: true })
                .then((response) => {
                // 登録成功
                if (response.data.success) {
                    // モーダル切り替え
                    changeScene(3, true);
                    // アンケートボタン非表示
                    document.getElementById("webinar-questionarrie-btn").style.display = "none";
                }
                // 登録失敗
                else {
                    window.alert(response.data.message);
                }
            })
                .catch((error) => {
                window.console.log(error);
                window.alert("アンケート回答に失敗しました");
            });
        }
    }
}
/**
 * お気に入りボタンイベント処理
 */
function initWebinarFavoriteButton() {
    const a = document.getElementById("webinar-favorite-btn");
    if (a === null) {
        return;
    }
    a.addEventListener("click", function (event) {
        const url = "/api/webinars/" + event.target.dataset.id + "/favorite";
        const role = event.target.dataset.role;
        // 登録
        if (role == "store") {
            axios
                .post(url, { withCredentials: true })
                .then(() => {
                // どんな結果でもエラーは表示しない
                a.classList.add("favorited");
                a.dataset.role = "remove";
            })
                .catch((error) => {
                window.console.log(error);
            });
        }
        // 登録解除
        else {
            axios
                .delete(url, { withCredentials: true })
                .then(() => {
                // どんな結果でもエラーは表示しない
                a.classList.remove("favorited");
                a.dataset.role = "store";
            })
                .catch((error) => {
                window.console.log(error);
            });
        }
    }, false);
}
/**
 * ビデオのイベント処理
 */
function initWebinarVideoPlay() {
    const video = document.getElementById("webinar-video");
    if (video === null)
        return;
    const webinarSlotId = video.dataset.id;
    if (webinarSlotId === null)
        return;
    let sec = 0;
    let timeoutId = null;
    const startTimer = () => {
        timeoutId = setTimeout(() => {
            sec += 1;
            startTimer();
        }, 1000);
    };
    video.addEventListener("pause", () => clearTimeout(timeoutId));
    video.addEventListener("seeking", () => clearTimeout(timeoutId));
    video.addEventListener("playing", () => startTimer());
    video.addEventListener("play", () => {
        if (sec === 0) {
            postPlayHistoryData(sec, webinarSlotId);
        }
    });
    video.addEventListener("ended", () => {
        window.console.log("ended");
        window.console.log(sec);
        if (sec >= 5) {
            postPlayHistoryData(sec, webinarSlotId);
        }
        clearTimeout(timeoutId);
        sec = 0;
    });
    window.addEventListener("beforeunload", () => {
        window.console.log("beforeunload");
        window.console.log(sec);
        if (sec >= 5) {
            postPlayHistoryData(sec, webinarSlotId);
        }
        clearTimeout(timeoutId);
        sec = 0;
    });
}
/**
 * 視聴履歴データを送信する
 *
 * @param time 再生時間
 * @param webinarSlotId webinarSlotId
 */
async function postPlayHistoryData(time, webinarSlotId) {
    const url = "/api/webinars/" + webinarSlotId + "/play";
    const postData = { time: parseInt(time) };
    try {
        await axios.post(url, postData);
        const span = document.getElementById("webinar-play-count");
        if (span !== null) {
            const count = parseInt(span.innerText, 10) + 1;
            span.innerText = count.toString();
        }
    }
    catch (error) {
        window.console.error(error);
    }
}
/**
 * 訪問回数のイベント処理
 */
function initWebinarVisit() {
    const app = document.getElementById("user-webinar-detail-app");
    // 訪問回数カウントアップ
    const url = "/api/webinars/" + app.dataset.id + "/visit";
    axios
        .post(url, { withCredentials: true })
        .then((response) => {
        //console.log(response);
        const span = document.getElementById("webinar-visit-count");
        let visitCount = parseInt(response.data.count);
        span.innerHTML = String(visitCount.toLocaleString());
    })
        .catch((error) => { });
}
